import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Row, Typography, Tabs } from 'antd';
import _ from 'lodash';
import Loading from 'components/Loading';
import { parseQueryParams } from 'utils/url';
// style
import 'assets/styles/shipment.scss';
// img
import sellonboardLogo from 'assets/images/logo_registered.png';
// request
import { getTrackingStatus } from 'requests/shipment';
import { generateShipmentTrackingUrl } from 'utils/common';

const { Title } = Typography;

const ShipmentTracking = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [title, setTitle] = useState('Tracking Order');
    const [loading, setLoading] = useState(true);
    const [awbs, setAwbs] = useState([]);
    const [trackingUrls, setTrackingUrls] = useState([]);

    useEffect(() => {
        const query = parseQueryParams(location);
        if (!query.awb) {
            navigate('/404');
        }

        getData(query.awb);
    }, [location]);

    const getData = async (awb) => {
        try {
            setLoading(true);

            if (awb) {
                const response = await getTrackingStatus({ awb: awb });

                setTitle(`Tracking Order #${response.order_number}`);

                if (awb.includes(',')) {
                    const awbItems = awb.split(',');

                    const urls = awbItems.map((awbItem) => {
                        const { url } = generateShipmentTrackingUrl(response.service_id, awbItem);
                        return url;
                    });

                    setAwbs(awbItems);
                    setTrackingUrls(urls);
                } else {
                    setAwbs([awb]);
                    const { url, type } = generateShipmentTrackingUrl(response.service_id, awb);
                    if (url) {
                        if (type === 'redirect') window.location.href = url;
                        else {
                            setTrackingUrls([url]);
                        }
                    }
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="shipment-tracking-wrapper">
            <Row className="shipment-tracking-header" align="middle" justify="space-between" gutter={[16, 16]}>
                <Title level={4} className="mb-0">
                    {title}
                </Title>
                <Row align="middle" className="shipment-tracking-powered">
                    <Title level={4} className="mb-0">
                        Powered by
                    </Title>
                    <a href="https://sellonboard.com/">
                        <img src={sellonboardLogo} className="ml-8" />
                    </a>
                </Row>
            </Row>
            {loading ? (
                <Loading />
            ) : (
                <div className="shipment-tracking-content">
                    {trackingUrls.length > 1 ? (
                        <Tabs>
                            {trackingUrls.map((trackingUrl, idx) => (
                                <Tabs.TabPane tab={`AWB ${awbs[idx]}`} key={idx}>
                                    <iframe
                                        src={trackingUrl}
                                        className="shipment-tracking-iframe"
                                        
                                        title={`Tracking iframe #${idx}`}
                                    ></iframe>
                                </Tabs.TabPane>
                            ))}
                        </Tabs>
                    ) : (
                        <iframe
                            src={trackingUrls[0]}
                            className="shipment-tracking-iframe"
                            title="Tracking iframe"
                        ></iframe>
                    )}
                </div>
            )}
        </div>
    );
};

export default ShipmentTracking;
